import React, { Component } from 'react'
import { Divider, Typography, withStyles } from '@material-ui/core'
import GeneralTable from '../../../Shared/GeneralTable'
import AddElementButton from '../../../Shared/AddElementButton'
import autobind from '../../../Utils/autobind'
import LicenseDialog from './LicenseDialog'
import { createPermissionAction, editPermissionAction, getPermissionsAction } from '../../../Actions/PermissionsAction'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { dateTimeFormat } from '../../../Utils/formats'
import moment from 'moment'
import { getPermissionsTypeAction } from '../../../Actions/TypesPermissionsAction'
import { getPermissionsAreaAction } from '../../../Actions/AreaPermissionsAction'
import { Edit, GetApp, HourglassEmpty } from '@material-ui/icons'
import { callSnackbar } from '../../../Utils/snackbar'

const style = () => ({
  title: {
    margin: "26px 0 12px 0 ",
  },
  inline: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
})

const tableInfo = [
  { name: "Número de orden", label: "order_id" },
  { name: "Descripción", label: 'description' },
  { name: "Fecha de inicio", label: 'date_start', format: dateTimeFormat },
  { name: "Fecha de término", label: 'date_end', format: dateTimeFormat },
  { name: "Estado", label: 'created_at', format: value => moment(value).diff(moment(new Date()), 'days') >= 30 ? "Vencido" : "Vigente" }
]

class Licenses extends Component {
  constructor() {
    super()
    this.state = {
      openAdd: false,
      openEdit: false,
      selected: null,
      loadingFile: false
    }
    autobind(Licenses, this)
  }

  componentDidMount() {
    const { match, getPermissions, getPermissionsAreas, getPermissionsTypes } = this.props
    const { sub_branch_id } = match.params
    const body = { sub_branch_id }
    getPermissions(body)
    getPermissionsAreas()
    getPermissionsTypes()
  }

  handleOpenAdd() {
    this.setState({ openAdd: !this.state.openAdd })
  }

  handleOpenEdit(row) {
    return () => {
      if (row) {
        const baseSelected = {
          ...row,
          date_start: moment(row.date_start).format("YYYY-MM-DDTHH:mm:ss"),
          date_end: moment(row.date_end).format("YYYY-MM-DDTHH:mm:ss")
        }
        return this.setState({ openEdit: !this.state.openEdit, selected: baseSelected })
      }
      this.setState({ openEdit: !this.state.openEdit, selected: row })
    }
  }

  handleCreate(params) {
    const { createPermission, match } = this.props
    const { sub_branch_id } = match.params
    const body = {
      ...params,
      sub_branch_id,
      date_created: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      date_modified: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      date_start: moment(params.date_start).format("YYYY-MM-DD HH:mm:ss"),
      date_end: moment(params.date_end).format("YYYY-MM-DD HH:mm:ss")
    }
    createPermission(body)
  }

  handleEdit(params) {
    const { selected } = this.state
    const { editPermission, match } = this.props
    const { sub_branch_id } = match.params
    const body = {
      ...params,
      sub_branch_id,
      date_created: selected.date_created,
      date_modified: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      date_start: moment(params.date_start).format("YYYY-MM-DD HH:mm:ss"),
      date_end: moment(params.date_end).format("YYYY-MM-DD HH:mm:ss"),
      id: selected.id
    }
    editPermission(body)
  }

  handleGotoFile(row) {
    return () => {
      const { user } = this.props
      const url = `https://app.safeasy.cl/model/pdf/ptc.php?id=${row.id}&u=${user?.account?.user?.id}`
      this.setState({ loadingFile: true })
      fetch(url).then((response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement("a")
          a.href = url
          a.download = `Permiso`
          a.click()
          this.setState({ loadingFile: false })
        })
      }).catch(() => {
        callSnackbar("Error al descargar documento", "error")
        this.setState({ loadingFile: false })
      })
    }
  }

  render() {
    const { classes, permissions } = this.props
    const { openAdd, openEdit, selected, loadingFile } = this.state
    const allPermissions = permissions.all || []

    const actions = [
      { name: "Editar", icon: Edit, action: this.handleOpenEdit },
      { name: "Descargar", icon: loadingFile ? HourglassEmpty : GetApp, action: this.handleGotoFile, disabled: () => loadingFile }
    ]
    return (
      <div className={classes.container}>
        <div className={classes.inline}>
          <Typography variant="h1" className={classes.title}>
            Tabla de permisos
          </Typography>
          <AddElementButton open={openAdd} onClick={this.handleOpenAdd}>Crear permiso</AddElementButton>
        </div>
        <LicenseDialog open={openAdd} onClose={this.handleOpenAdd} onCreate={this.handleCreate} />
        <LicenseDialog open={openEdit} onClose={this.handleOpenEdit()} onCreate={this.handleEdit} baseParams={selected} edit />
        <Divider style={{ marginBottom: 24 }} />
        <GeneralTable info={tableInfo} data={allPermissions} actions={actions} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  permissions: state.permissions,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  getPermissions: body => dispatch(getPermissionsAction(body)),
  createPermission: body => dispatch(createPermissionAction(body)),
  editPermission: body => dispatch(editPermissionAction(body)),
  getPermissionsTypes: body => dispatch(getPermissionsTypeAction(body)),
  getPermissionsAreas: body => dispatch(getPermissionsAreaAction(body))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(Licenses)))